import { useQuery } from '@tanstack/react-query';
import { getCoverage } from '../orders.api';

export function useCoverage(serviceCode?: string) {
  return useQuery({
    queryKey: ['orders', 'analytics', 'coverage', serviceCode ?? null],
    queryFn: () => getCoverage(serviceCode),
    staleTime: 60 * 1000,
  });
}
